import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Page from 'Common/Layout/Page';
import HelpToolTip from '../../../../../Common/HelpToolTip';
import ContractsDatatable from '../../Datatables/ContractsDatatable';
import ViewAlert from '../../Components/ViewAlert/ViewAlert';
import { withClsCompTracking } from '../../../../../Telemetry/telemetry.service';
import Columns from '../../Datatables/ColumnDefinitions';
import { getScriptAllocationData, clearAllScriptAllocationUpdates, getScriptAllocationCount } from '../../../../../Redux/Actions/Script.Allocation.Actions';
import CloseButton from '../../../../../Common/CloseButton/CloseButton';
import classes from '../contract-views.module.css';
import { qualYearSelect } from 'Redux/Selectors/Contracts.Globals.Selectors';

const ScriptAllocationManagement = withClsCompTracking('Script Allocation Table')(ContractsDatatable);

const ScriptAllocation = ({ handleActiveModal }) => {
	const dispatch = useDispatch();
	const { selected: qualYear } = useSelector(qualYearSelect);
	let [scriptyear, setYear] = useState(qualYear.toString());
	const [fireShow, setFireShow] = useState(false);
	const types = useSelector(state => state.contract_globals.appointment_types.selected);
	const allocation = useSelector(state => state.allocation);
	const handleGetScriptAllocation = (contractTypes, year, query, exportData) =>
		dispatch(getScriptAllocationData(contractTypes, year, query, exportData));
	const handleClearScriptAllocationUpdates = () => dispatch(clearAllScriptAllocationUpdates());
	const handleScriptDateCount = (contractTypes, year) => dispatch(getScriptAllocationCount(contractTypes, year));
	const handleQualyearUpdate = (year) => setYear(year);	
	const amendments = allocation.updated.length;
	const title = `Contracts Script Allocation (${types.join(', ')}) ${scriptyear}`;
	document.title = `Contract Management - ${title}`;

	return (
		<>
			<Page title={title}>
			</Page>
			<HelpToolTip title={`Script Allocation Editing Help`} instructions={['Sort by clicking the column header.']} />
			<ViewAlert
				show={allocation.message !== ''}
				message={allocation.message}
				errors={allocation.errors}
				clearMessage={clearAllScriptAllocationUpdates}
			/>
			<ScriptAllocationManagement
				keyField={'markingTeamId'}
				columns={Columns.ScriptAllocationColumns}
				contractTypes={types}
				year={scriptyear}
				handleGetData={handleGetScriptAllocation}
				handleAddUpdates={null}
				handleClearUpdates={handleClearScriptAllocationUpdates}
				fireShow={fireShow}
				setFireShow={setFireShow}
				handleGetCount={handleScriptDateCount}
				updateQualYear={handleQualyearUpdate}
				amendments={amendments}
				{...allocation}
			/>
			<span className={classes['action-buttons']}>
				<CloseButton closeOnClick={() => handleActiveModal('')} hasUpdates={allocation.updated && allocation.updated.length > 0} />
			</span>
		</>
	);
};

export default ScriptAllocation;
